<template>
  <Card>
    <h1 slot="Title">US Standard General Ledger Account (GLAC) (6100)</h1>
    <div slot="MainContent">
      <p>
        General ledger accounts are the backbone to any accounting and financial information that comes out of an organization. They cover all aspects of a business with regard to the flow of money and can be broken down to as fine a detail as an organization chooses. The accounts are divided into categories and can give the balance of any area of the business at a glance.
      </p>
      <p> 202011D20 A76VV 131096QLOG <b><u>6100</u></b>.2617 WBS, Internal Order or Cost Center 1000000067 021001</p>
    </div>
    <div slot="Notes">
      <p><strong>US Standard General Ledger Account (GLAC)<br /> </strong></p>
      <p>The General Ledger also commonly referred to as an accounting ledger, a general ledger is a primary accounting record used by a business to keep track of all the financial transactions the company makes.&nbsp; All financial transactions, debits and credits are recorded or posted,&rdquo;&nbsp; in the general ledger, regardless of whether or not they also post to a subsidiary ledger (sub-ledger), such as accounts receivable or cash.&nbsp; These values can provide the information used to generate all of the organization&rsquo;s financial statements.&nbsp;</p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'TestPage',
  
  data() {
    return {
    }
  }
  
}
</script>